export const AI = ["Chat-gpt", "Google Gemini", "MS Bing", "Naver Clova", 'Claude']

export const boxType = [
    {label: "형태 선택", key: "notSelected"},
    {label: "라디오 버튼", key:"radio"},
    {label: "체크박스", key:"check"},
    {label: "한줄 텍스트 박스", key:"shortTB"},
    {label: "여러줄 텍스트 박스", key:"longTB"},
]
export const typeIdMap = {
    "radio": 5,
    "check": 6,
    "shortTB": 7,
    "longTB": 8,
}
export const boxTypeOnly3 = [
    {label: "한줄 텍스트 박스", key:"shortTB"},
    {label: "여러줄 텍스트 박스", key:"longTB"},
]

export const att = ['selection', 'value']
